import type { Xinglet } from '@xing-com/crate-xinglet';

import { Login } from './login';

export default class LoginXinglet implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <Login />;
  }
}
